import { css } from '@emotion/core';
import theme from '../../themes/default';

const {
  spacing,
  color,
  color: { designSystem },
} = theme;

const styles = {
  button: {
    primary: {
      padding: `${spacing.small} ${spacing.medium}`,
      color: color.white,
      backgroundColor: color.purple3,
      hover: {
        backgroundColor: designSystem.buttonStates.primary.hover,
      },
      active: {
        backgroundColor: designSystem.buttonStates.primary.selected,
      },
      selected: {
        backgroundColor: designSystem.buttonStates.primary.selected,
      },
      disabled: {
        color: designSystem.blackOpacity38,
        backgroundColor: designSystem.blackOpacity12,
      },
      focused: {
        boxShadow: `inset 0 0 0 1px ${designSystem.blackOpacity87}`,
        backgroundColor: designSystem.buttonStates.primary.active,
      },
    },
    secondary: {
      border: `1px solid ${designSystem.blackOpacity38}`,
      padding: `${spacing.small} ${spacing.medium}`,
      color: color.purple3,
      backgroundColor: 'transparent',
      hover: {
        backgroundColor: designSystem.background.lightPurple.hover,
      },
      active: {
        backgroundColor: designSystem.background.lightPurple.pressed,
      },
      selected: {
        backgroundColor: designSystem.buttonStates.secondary.selected,
      },
      disabled: {
        color: designSystem.blackOpacity38,
        border: `1px solid ${designSystem.blackOpacity12}`,
        backgroundColor: designSystem.grey10,
      },
      focused: {
        border: `1px solid ${designSystem.blackOpacity87}`,
        backgroundColor: designSystem.background.lightPurple.focus,
      },
    },
    text: {
      padding: spacing.xxSmall,
      color: color.purple3,
      backgroundColor: 'transparent',
      hover: {
        backgroundColor: color.designSystem.buttonStates.secondary.hover,
      },
      active: {
        backgroundColor: color.designSystem.buttonStates.secondary.active,
      },
      selected: {
        backgroundColor: color.designSystem.buttonStates.secondary.selected,
      },
      disabled: {
        color: color.designSystem.blackOpacity38,
        backgroundColor: 'transparent',
      },
      focused: {
        boxShadow: `inset 0 0 0 1px ${designSystem.blackOpacity87}`,
        backgroundColor: designSystem.background.lightPurple.focus,
      },
    },
  },
  iconButton: {
    primary: {
      padding: `${spacing.small} ${spacing.medium}`,
      color: color.white,
      backgroundColor: color.purple3,
      hover: {
        backgroundColor: color.designSystem.buttonStates.primary.hover,
      },
      active: {
        backgroundColor: color.designSystem.buttonStates.primary.active,
      },
      selected: {
        backgroundColor: color.designSystem.buttonStates.primary.selected,
      },
      disabled: {
        color: color.designSystem.blackOpacity38,
        backgroundColor: color.designSystem.blackOpacity12,
      },
      focused: {},
    },
    secondary: {
      padding: `${spacing.small} ${spacing.medium}`,
      color: color.designSystem.blackOpacity60,
      backgroundColor: 'transparent',
      hover: {
        backgroundColor: color.designSystem.background.grey.hover,
      },
      active: {
        backgroundColor: color.beige,
      },
      selected: {
        color: color.designSystem.purple70,
        backgroundColor: color.purple2,
      },
      disabled: {
        color: color.designSystem.blackOpacity38,
        backgroundColor: 'transparent',
      },
      focused: {
        border: `1px solid ${designSystem.blackOpacity87}`,
        backgroundColor: color.designSystem.background.grey.focus,
      },
    },
  },
};

const container = ({ type, selected, context }) => {
  const { [type]: tokensForType } = styles[context];

  const stylesForType = tokensForType
    ? css`
        border: ${tokensForType.border};
        padding: ${tokensForType.padding};
        color: ${selected ? tokensForType.selected.color : tokensForType.color};
        background-color: ${selected
          ? tokensForType.selected.backgroundColor
          : tokensForType.backgroundColor};

        &:hover {
          background-color: ${selected
            ? color.designSystem.background.lightPurple.hover
            : tokensForType.hover.backgroundColor};
        }

        &:active {
          background-color: ${tokensForType.active.backgroundColor};
        }

        &:disabled {
          cursor: default;
          pointer-events: all;
          background-color: ${tokensForType.disabled.backgroundColor};
          border: ${tokensForType.disabled.border};
          color: ${tokensForType.disabled.color};
        }

        &:focus {
          background-color: ${selected
            ? color.designSystem.background.lightPurple.focus
            : tokensForType.focused.backgroundColor};
          border: ${tokensForType.focused.border};
          box-shadow: ${tokensForType.focused.boxShadow};
        }
      `
    : '';

  return css`
    ${stylesForType};
    min-width: auto;
    text-transform: none;
    border-radius: ${theme.borderRadius.medium};
    font-weight: ${theme.font.weight.semiBold};

    &:disabled {
      &:hover {
        background-color: ${tokensForType.disabled.backgroundColor};
        border: ${tokensForType.disabled.border};
        color: ${tokensForType.disabled.color};
      }
    }
  `;
};

export default {
  container: {
    base: container,
  },
};
